module.exports = __webpack_public_path__ + "static/favicon-128-bd642730148eec28982bd4926163dc3f.png";